import * as ActionTypes from '../actions/types/OnboardActionTypes';

const initialState = {
  step: 1,
  isSlugAvailable: true,
  primaryProduct: 'REGISTRY',
  // New Onboard Flow:
  businessUnitComponent: '',
  questions: [],
  isSigningUp: false,
  questionsLoaded: false,
  currentQuestionNumber: 0,
  questionNumber: 0,
  isDeferSelectProduct: false,
  submitDelayActive: false,
};

const onboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.SLUG_AVAILABILITY_RECEIVED: {
      return Object.assign({}, state, { isSlugAvailable: action.payload });
    }
    case ActionTypes.SLUG_SUGGESTIONS_RECEIVED: {
      return Object.assign({}, state, { slugSuggestions: action.payload });
    }
    // New Perfect Wedding Flow actions
    case ActionTypes.RECEIVE_QUESTIONS: {
      return { ...state, questionsLoaded: true, ...action.payload.data };
    }
    case ActionTypes.UPDATE_QUESTION_NUMBER: {
      const questionNumber = action.payload;
      return { ...state, questionNumber };
    }
    case ActionTypes.REQUEST_QUESTIONS: {
      return { ...state, questionsLoaded: false };
    }
    case ActionTypes.REQUEST_SIGNUP: {
      return { ...state, isSigningUp: true };
    }
    case ActionTypes.ONBOARDING_COMPLETED: {
      return { ...state, isSigningUp: false, ...action.payload.data };
    }
    case ActionTypes.UPDATE_WEDDING_DATE: {
      return { ...state, ...action.payload };
    }
    case ActionTypes.SET_BUSINESS_UNIT_COMPONENT: {
      return Object.assign({}, state, { businessUnitComponent: action.payload });
    }
    case ActionTypes.SET_DEFER_SELECT_PRODUCT: {
      return Object.assign({}, state, { isDeferSelectProduct: action.payload });
    }
    case ActionTypes.UPDATE_SUBMIT_DELAY_ACTIVE: {
      return Object.assign({}, state, { submitDelayActive: action.payload });
    }
    default:
      return state;
  }
};

export default onboardReducer;



// WEBPACK FOOTER //
// ./src/reducers/onboard.js